export default __webpack_public_path__ + "static/media/site-logo.a114d994.svg";